<template>
  <div class="welcome-banner">
    <div class="row mt-5">
      <div class="col-md-12 mb-5">
        <h4 id="v-step-2">Übersicht</h4>
      </div>
      <div class="row col-md-12 dashboard-dates">
        <div class="col-lg-4 date1">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Geburtsdatum ist erforderlich.',
                }"
              >
                <v-text-field
                  label="Datum ab"
                  placeholder="TT/MM/JJJJ"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  v-model="formattedDate"


                ></v-text-field>

              </ValidationProvider>
            </template>
            <v-date-picker
              locale="de-at"
              :first-day-of-week="1"
              v-model="date"
              :max="minDate"
              no-title
              scrollable
              @change="changeDateFormat()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                ABBRECHEN
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

        </div>

        <div class="col-lg-4">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="toDate"
            transition="scale-transition"
            offset-y
            max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Geburtsdatum ist erforderlich.',
                }"
              >
                <v-text-field
                  label="Datum bis"
                  placeholder="TT/MM/JJJJ"
                  :error-messages="errors[0]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  v-model="formattedToDate"
                ></v-text-field>

              </ValidationProvider>
            </template>
            {{toDateMin}}
            <v-date-picker
              locale="de-at"
              :first-day-of-week="1"
              v-model="toDate"
              :min="toDateMin"
              :max="maxDate"
              no-title
              scrollable
              @change="changetoDateFormat()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">
                ABBRECHEN
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu1.save(toDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
    </div>
      <!-- Notification div -->
    <div class="row mt-5" v-if="notifications.length">
      <div class="col-md-12 mb-5">
        <!-- <h4 id="v-step-2">Inbox</h4> -->
      </div>
      <div class="col-md-8 bookings-list-status">
        <div class="inbox-listing">
        <ul>
          <li v-for="(notification, i) in notifications" :key="'grdf' + i">
            <div @click="getNotificationsDetails(notification)">
              <b>{{ notification.count }}</b> {{ notification.type }}
            </div>
          </li>
        </ul>
        </div>
      </div>
    </div>
    <!-- order counts -->
    <div class="row graph-revanu mt-5">
      <div class="col-md-12">
        <ul>
          <li>
            <div id="v-step-5">
              Umsatz
              <span
                >€

                {{revenue ? revenue : "0.00" }}</span
              >
            </div>
          </li>
          <li>
            <div id="v-step-5">
              # Bestellungen
              <span
                >

                {{orders ? orders : "0" }}</span
              >
            </div>
          </li>

        </ul>
      </div>
    </div>
    <div class="row graph-revanu mt-5">
      <div class="graph col-md-12">
        <div class="ind-wrapper">
          <div class="bookin-ind">
            <div
              style="height: 15px; width: 15px; background-color: #3d5a80"
            ></div>
            <p>Umsatz</p>
            <line-chart
            :chart-data="progressCharData"
            :options="options"
            :height="300"
            :width="800"
            v-if="progressCharData"></line-chart>
          </div>

        </div>
      </div>
    </div>
    <div class="row graph-revanu mt-5">
      <div class="graph col-md-12">

        <div class="ind-wrapper">
          <div class="bookin-ind">
            <div
              style="height: 15px; width: 15px; background-color: #ff9419"
            ></div>
            <p>Bestellungen</p>
            <line-chart
              :chart-data="bookingCharData"
              :options="options"
              :height="300"
              :width="800"
              v-if="bookingCharData"></line-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- <center>
    	<img src="/media/images/book/welcome-dashboard.jpg">
      <h2>Willkommen bei Gustoreich</h2>

      <div>
        <span style="font-size: 16px">Aktuell sind keine Dokumente verfügbar</span>
      </div>
    </center> -->
    <!-- <notifications group="bookings" position="bottom right" /> -->
    <div style="margin-top: 20px;">
        <div class="col-md-12 mb-5">
          <h4 id="v-step-2">Top-Produkte</h4>
        </div>
        <v-simple-table class="record-table">
          <thead>
            <tr>
              <th class="text-center align-middle" width="5%">
                Seriennummer
              </th>
              <th
                width="25%"
                class="text-center align-middle">
                Produktname
              </th>

              <th class="text-center align-middle" width="25%">Einheit</th>
              <th class="text-center align-middle" width="25%">Preis pro Einheit</th>
              <th class="text-center align-middle" width="25%">Menge</th>
              <th class="text-center align-middle" width="25%">Preis</th>

            </tr>
          </thead>

          <tbody v-if="topProducts.length">
            <tr v-for="(product, i) in topProducts" :key="product.id">
              <td
                class="align-middle clickable-td"

              >
                {{ i + 1 }}
              </td>
              <td
                class="align-middle clickable-td"
              >
                {{
                  product.product_name.length > 60
                    ? product.product_name.substr(0, 60) + "..."
                    : product.product_name
                }}
              </td>
              <td
                v-if="product.unit"
                class="align-middle clickable-td text-center"
              >
                {{product.quantity_measure}} {{
                  product.unit ? product.unit : "-"
                }}
              </td>

              <td
                v-if="product.unit_price"
                class="align-middle clickable-td text-center"
              >
                {{
                  product.unit_price ? product.unit_price : "0,00"
                }} €
              </td>
              <td
                v-if="product.quantity"
                class="align-middle clickable-td text-center"
              >
                {{
                  product.quantity ? product.quantity : "0"
                }}
              </td>
              <td
                v-if="product.total"
                class="align-middle clickable-td text-center"
              >
                {{
                  product.total ? product.total.toFixed(2)
                            .replace(".", ","): "0,00"
                }} €
              </td>

              <td
                v-else
                class="align-middle clickable-td text-center"
              >
                -
              </td>


            </tr>
          </tbody>
          <tbody v-else-if="loading_products" class="loading-tbody">
            <td colspan="10">
              Wird geladen...
              <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </td>
          </tbody>
          <tbody v-else class="loading-tbody">
            <tr>
              <td colspan="10">Keine Einträge gefunden</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
  </div>
</template>

<style scoped>
h2 {
  font-family: "ubuntu";
}
</style>

<script>
import Vue from "vue";
import providerAPI from "@/api/provider";
import { mapGetters } from "vuex";
import LineChart from "@/components/provider/helper/charts/line";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
import Loader from "@/components/admin/layout/Loader.vue";
import moment from "moment";
import { LOGOUT } from "@/core/services/store/auth.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
Vue.use(Notifications);
export default {
  name: "dashboard",
  data() {
    return {
      menu: false,
      menu1: false,
      toDateMin: moment().startOf('month').format('DD/MM/YYYY'),
      minDate: new Date(Date.now())
        .toISOString()
        .substr(0, 10),
      maxDate: moment().endOf('month').format('YYYY-MM-DD'),
      notifications: [],
      progressCharData: {},
      bookingCharData: {},
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.label + ": " + tooltipItems.yLabel;
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handleChart,
      },
      graphType: "Last 7 days",
      orders: 0,
      revenue: '0,00',
      date: "",
      toDate: "",
      formattedDate: "",
      formattedToDate: "",
      topProducts: [],
    }
  },
  mounted() {
     this.formattedDate     = moment().startOf('month').format('DD/MM/YYYY');
     this.formattedToDate   = moment().endOf('month').format('DD/MM/YYYY');
     this.date              = moment().startOf('month').format('YYYY-MM-DD');
     this.toDate            = moment().endOf('month').format('YYYY-MM-DD');
     this.getNotifications();
  },
  components: {
    LineChart,
  },
  methods: {
    changeDateFormat(){
      this.formattedDate = moment(String(this.date)).format("DD/MM/YYYY");
      var fromDate  = this.formattedDate;
      fromDate      = fromDate.split("/");
      var minDate   = new Date( fromDate[2], fromDate[1] - 1, fromDate[0]);
      this.maxDate  = moment().endOf('month').format('YYYY-MM-DD');
              // console.log(this.maxDate);
      this.getNotifications();
    },
    changetoDateFormat(){
      this.formattedToDate = moment(String(this.toDate)).format("DD/MM/YYYY");
      this.getNotifications();

    },
    getNotifications () {
      let data = {
         producer_id: this.currentUser.id,
         graph_type: this.graphType,
         from_date: this.date,
         to_date: this.toDate
        };
      providerAPI
        .dashboardNotification(data)
        .then((response) => {
          if (response.status == "success") {
            let keyArr      = [];
            let revenueArr  = [];
            let bookingArr  = [];
            this.revenue    = response.order_data.revenue.toFixed(2).replace(".", ",");
            this.orders     = response.order_data.orders;
            this.notifications = response.notification;
            this.topProducts = response.top_products;
            if (response.graph_data.length) {
              response.graph_data.forEach((item) => {
                keyArr.push(item.key);
                revenueArr.push(item.total_amount.toFixed(2));
                bookingArr.push(item.total_orders);
              });
            }
            this.progressCharData = {
              labels: keyArr,
              datasets: [
                {
                  label: "Umsatz",
                  borderColor: ["#3d5a80"],
                  pointBackgroundColor: "white",
                  borderWidth: 2,
                  pointBorderColor: "#3d5a80",
                  data: revenueArr,
                },
              ],
            };
            this.bookingCharData = {
              labels: keyArr,
              datasets: [
                {
                  label: "Bestellungen",
                  borderColor: ["#ff9419"],
                  pointBackgroundColor: "white",
                  borderWidth: 2,
                  pointBorderColor: "#ff9419",
                  data: bookingArr,
                },
              ],
            };
          }
        }, (error) => {
          if (error.response.status == 401){
            localStorage.removeItem("userCheckoutDetails");
            this.$store.dispatch(LOGOUT).then(() => {
              setTimeout(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$router.push({ name: "login" });
              }, 2000);
            });
          }
        });
    },
    getNotificationsDetails(notification){

      if (notification.type == "Niedriger lagerstand" || notification.type == "Statusänderung des Produktes") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'edit-product/'+ notification.product_id});
      }
      if (notification.type == "Neues Produkt durch den Administrator angelegt") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'edit-product/'+ notification.product_id});
      }
      if (notification.type == "Support Antwort") {
        this.readStatusUpdate(notification.id);
        this.$router.push({ path: 'support-response/' + btoa(btoa(notification.support_id))});
      }
    },
    readStatusUpdate (id) {
      let data = {
         id: [id],

        };
      providerAPI
        .readStatusUpdate(data)
        .then((response) => {
          if (response.status == "success") {

          }
        });
    }
  },

  watch: {
    graphType: function (val) {
      this.getNotifications();
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  }
};
</script>
<style type="text/css" scoped>
  .bookings-list-status ul {
  list-style: none;
  margin-right: 20px;
  padding: 0 !important;
  margin-top: 0;
}

.bookings-list-status ul li {
  background-color: #f1f1f1;
  margin-bottom: 10px;
  padding: 13px 20px;
  border-radius: 5px;
  border-left: 3px solid #3d5a80;
}

.graph-revanu ul li {
  background-color: #f1f1f1;
  border-left: 3px solid #3d5a80;
  border-radius: 5px;
  width: calc(33.33% - 10px);
  padding: 20px 15px;
  margin-right: 15px;
}

.graph-revanu ul {
  display: flex;
  list-style: none;
  padding: 0 !important;

  margin-right: 0 !important;
}

.graph-revanu ul li span {
  display: block;
  font-size: 20px;
  font-weight: bold;
  color: #e57a00;
}

.graph-revanu ul li span {
  word-break: break-all;
}
.ind-wrapper {
  display: flex;
  align-items: center;
}

.ind-wrapper div {
  display: flex;
  align-items: center;
  margin-right: 18px;
}

.ind-wrapper div p {
  margin-bottom: 0;
  font-size: 12px;
}

.ind-wrapper div div {
  margin-right: 10px;
}

</style>
